import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, Phone, ChevronDown, Car } from 'lucide-react';
import Logo from "../Assets/logo (4).png"

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);

  const navItems = [
    { 
      name: 'Home', 
      link: '/',
    },
    { 
      name: 'Force Urbania', 
      link: '/urbaniabangalore',
      dropdown: [
        { name: '16 Seater', link: '/urbania-16-seater-bangalore' },
        { name: '12 Seater', link: '/urbania-12-seater-bangalore' },
        { name: '9 Seater', link: '/urbania-9-seater-bangalore' }
      ]
    },
    // { 
    //   name: 'Innova Hybrid', 
    //   link: '/innova-hybrid',
    // },
     { 
      name: 'Innova', 
      link: '/innovabangalore',
      dropdown: [
        { name: 'Innova Hybrid', link: '/innovahybrid-booking-bangalore' },
        { name: 'Innove Crysta', link: '/innova-booking-bangalore' },
        { name: 'Ertiga SUV', link: '/ertiga-car-rental-bangalore' }
      ]
    },
    { 
      name: 'Tempo Traveller', 
      link: '/tempo-traveller',
      dropdown: [
        { name: '9 Seater', link: '/9-seater-tempo-traveller-booking-bangalore' },
        { name: '12 Seater', link: '/12-seater-tempo-traveller-booking-bangalore' }
      ]
    },
    { 
      name: 'Buses', 
      link: '/bus',
      dropdown: [
        { name: '20 Seater Bus', link: '/20-seater-bus-rental-bangalore' },
         { name: '30 Seater Bus', link: '/30-seater-bus-rental-bangalore' },
        { name: '40 Seater Bus', link: '/40-seater-bus-rental-bangalore' },
        { name: '50 Seater Bus', link: '/50-seater-bus-rental-bangalore' }
      ]
    },
    { 
      name: 'Contact', 
      link: '/contact',
    },
  ];

  // Close menu when clicking outside or resizing to desktop
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 768) {
        setIsMenuOpen(false);
        setOpenDropdown(null);
      }
    };

    const handleClickOutside = (event) => {
      if (isMenuOpen && !event.target.closest('.mobile-menu')) {
        setIsMenuOpen(false);
        setOpenDropdown(null);
      }
    };

    window.addEventListener('resize', handleResize);
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      window.removeEventListener('resize', handleResize);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  const toggleDropdown = (itemName) => {
    setOpenDropdown(openDropdown === itemName ? null : itemName);
  };

  return (
    <header className="sticky top-0 z-50 w-full bg-white shadow-md">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="text-xl font-bold text-blue-700">
          <img src={Logo} alt="UrbaniaNavaCabs Logo" className="h-16 w-auto inline-block mr-2" />
            {/* <span className="text-orange-500">Urbania</span>NavaCabs */}
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-4">
            {navItems.map((item) => (
              <div key={item.name} className="relative group">
                {item.dropdown ? (
                  <>
                    <button className="flex items-center px-3 py-2 text-gray-700 hover:text-blue-600 font-medium transition-colors">
                      {item.name}
                      <ChevronDown className="ml-1 w-4 h-4" />
                    </button>
                    <div className="absolute left-0 top-full mt-1 w-48 bg-white rounded-lg shadow-lg border py-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
                      {item.dropdown.map((option) => (
                        <Link
                          key={option.name}
                          to={option.link}
                          className="block px-4 py-2 text-gray-700 hover:bg-blue-50 hover:text-blue-600"
                        >
                          {option.name}
                        </Link>
                      ))}
                    </div>
                  </>
                ) : (
                  <Link
                    to={item.link}
                    className="px-3 py-2 text-gray-700 hover:text-blue-600 font-medium"
                  >
                    {item.name}
                  </Link>
                )}
              </div>
            ))}
            <Link
              to="/contact"
              className="flex items-center bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 ml-4"
            >
              <Phone className="w-4 h-4 mr-2" />
              Book Now
            </Link>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2 rounded-lg hover:bg-gray-100"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label="Toggle menu"
          >
            {isMenuOpen ? (
              <X className="w-6 h-6 text-gray-700" />
            ) : (
              <Menu className="w-6 h-6 text-gray-700" />
            )}
          </button>
        </div>

        {/* Mobile Menu Overlay */}
        {isMenuOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 z-40 md:hidden" onClick={() => setIsMenuOpen(false)} />
        )}

        {/* Mobile Menu Panel */}
        <div className={`mobile-menu fixed top-0 right-0 h-full w-4/5 max-w-sm bg-white shadow-xl z-50 transform transition-transform duration-300 ease-in-out md:hidden ${
          isMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}>
          {/* Mobile Menu Header */}
          <div className="flex items-center justify-between p-4 border-b">
            <Link to="/" className="text-lg font-bold text-blue-700" onClick={() => setIsMenuOpen(false)}>
              <span className="text-orange-500">Urbania</span>NavaCabs
            </Link>
            <button
              onClick={() => setIsMenuOpen(false)}
              className="p-2 rounded-lg hover:bg-gray-100"
              aria-label="Close menu"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          {/* Mobile Menu Content */}
          <div className="h-[calc(100vh-64px)] overflow-y-auto">
            <div className="p-4">
              {/* Menu Items */}
              <div className="space-y-1">
                {navItems.map((item) => (
                  <div key={item.name} className="border-b border-gray-100 last:border-b-0">
                    {item.dropdown ? (
                      <div className="py-2">
                        <button
                          onClick={() => toggleDropdown(item.name)}
                          className="flex items-center justify-between w-full py-3 text-gray-700 hover:text-blue-600 font-medium"
                        >
                          <div className="flex items-center">
                            {/* <Car className="w-4 h-4 mr-3 text-blue-500" /> */}
                            {item.name}
                          </div>
                          <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${
                            openDropdown === item.name ? 'rotate-180' : ''
                          }`} />
                        </button>
                        
                        {/* Dropdown Items */}
                        <div className={`overflow-hidden transition-all duration-200 ${
                          openDropdown === item.name ? 'max-h-96' : 'max-h-0'
                        }`}>
                          <div className="pl-7 pr-4 pb-2 space-y-1">
                            {item.dropdown.map((option) => (
                              <Link
                                key={option.name}
                                to={option.link}
                                className="block py-2.5 px-4 text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg"
                                onClick={() => {
                                  setIsMenuOpen(false);
                                  setOpenDropdown(null);
                                }}
                              >
                                {option.name}
                              </Link>
                            ))}
                          </div>
                        </div>
                      </div>
                    ) : (
                      <Link
                        to={item.link}
                        className="flex items-center py-3 text-gray-700 hover:text-blue-600 font-medium"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        {item.name}
                      </Link>
                    )}
                  </div>
                ))}
              </div>

              {/* Mobile Book Now Button */}
              <div className="mt-8 p-4 bg-blue-50 rounded-lg">
                <div className="text-center mb-4">
                  <h3 className="font-bold text-gray-800 mb-1">Ready to Book?</h3>
                  <p className="text-sm text-gray-600">Get your perfect vehicle now</p>
                </div>
                <Link
                  to="/contact"
                  className="flex items-center justify-center w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 font-medium"
                  onClick={() => setIsMenuOpen(false)}
                >
                  <Phone className="w-5 h-5 mr-2" />
                  Book Now
                </Link>
              </div>

              {/* Contact Info */}
              <div className="mt-6 pt-6 border-t border-gray-200">
                <h4 className="font-medium text-gray-700 mb-3">Need Help?</h4>
                <a href="tel:+919916788688" className="flex items-center text-blue-600 font-medium mb-2">
                  <Phone className="w-4 h-4 mr-2" />
                  Call: +91 99647 58999
                </a>
                <p className="text-sm text-gray-500 mt-4">
                  24/7 Customer Support Available
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;